document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger)

    if($('.Home').length){
        var currentMainContent = '.BodyLayout-mainContent';
        var currentDocumentOffset = $(document).height();
        var currentWindowOffset = $(window).height();
        var currentHeaderHeight = $('.HeroHome').height();
        var currentFooterHeight = $('.SiteFooter').height();
        var currentResaHeight = $('.HeroResa').height();
        var currentMainContentHeight = currentDocumentOffset - currentHeaderHeight - currentFooterHeight - currentResaHeight - currentWindowOffset;
        // console.log(currentMainContentHeight);

        // gsap.utils.toArray('.MainContent_interlude').forEach((interlude, i) => {
        //     interlude.bg = interlude.querySelector('.MainContent_interlude-bg')

        //     if(i) {
        //         interlude.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`
        //         gsap.to(interlude.bg, {
        //             backgroundPosition: `50% ${innerHeight / 2}px`,
        //             ease: "none",
        //             scrollTrigger: {
        //                 trigger: interlude,
        //                 scrub: true
        //             }
        //         })
        //     } else {
        //         interlude.bg.style.backgroundPosition = `50% 0px`
        //         gsap.to(interlude.bg, {
        //             backgroundPosition: `50% ${innerHeight / 2}px`,
        //             ease: "none",
        //             scrollTrigger: {
        //                 trigger: interlude,
        //                 start: "top top",
        //                 end: "bottom top",
        //                 scrub: true
        //             }
        //         })
        //     }
        // });
    }

    
})

$('.fluent').each(function() {
    var currentFluent = this;
    // var tween_fluent = new TimelineMax();

    // tween_fluent
    //     .to(currentFluent, 1, { opacity: 0, ease: Linear.easeNone });

    // new ScrollMagic.Scene({
    //         triggerElement: currentFluent,
    //         duration: "65%"
    //     })
    //     .setTween(tween_fluent)
    //     .addTo(scrollMagicController);

    gsap.to(this, {
        opacity: 0,
        ease: Linear.easeNone,
        scrollTrigger: {
            trigger: currentFluent,
            start: "top bottom",
            end: "center center",
            scrub: true
        }
    })
});

/////////////////////////////////////////////
/////////////Scroll Magic////////////////////
///////////////////////////////////////////
// $(window).load(function(){

//     if($('.Home').length){
//         var currentMainContent = '.BodyLayout-mainContent';
//         var currentDocumentOffset = $(document).height();
//         var currentWindowOffset = $(window).height();
//         var currentHeaderHeight = $('.HeroHome').height();
//         var currentFooterHeight = $('.SiteFooter').height();
//         var currentResaHeight = $('.HeroResa').height();
//         var currentMainContentHeight = currentDocumentOffset - currentHeaderHeight - currentFooterHeight - currentResaHeight - currentWindowOffset;
//         // console.log(currentMainContentHeight);
//         new ScrollMagic.Scene({ triggerElement: currentMainContent, triggerHook: "onCenter"})
//             .setTween($('.MagellanMenu'), {transform: "translate(-100px,0)", ease: Power3.easeOut})
//             .addTo(scrollMagicHomeController);

//         new ScrollMagic.Scene({ triggerElement: currentMainContent, triggerHook: "onCenter", offset: currentMainContentHeight})
//             .setTween($('.MagellanMenu'), {transform: "translate(0,0)", ease: Power3.easeOut})
//             .addTo(scrollMagicHomeController);

//         // $('.section-thumb img').each(function(){
//         //     var currentThumb = this;
//         //     var tweenThumb = new TimelineMax()
//         //         .to(currentThumb, 1, {marginTop: "-160px", ease: Linear.easeNone});
//         //
//         //     new ScrollMagic.Scene({
//         //         triggerElement: currentThumb,
//         //         triggerHook: "onEnter",
//         //         duration: 2000
//         //     })
//         //         .setTween(tweenThumb)
//         //         .addTo(scrollMagicHomeController);
//         // });
//         $('.section-thumb .handler').each(function(){
//             var currentThumbHandler = this;
//             var tweenThumbHandler = new TimelineMax()
//                 .to(currentThumbHandler, 1, {transform: "translate(0,-300px)", ease: Linear.easeNone});

//             new ScrollMagic.Scene({
//                 triggerElement: currentThumbHandler,
//                 triggerHook: "onEnter",
//                 duration: 2000
//             })
//                 .setTween(tweenThumbHandler)
//                 .addTo(scrollMagicHomeController);
//         });
//         // $('.section-thumb img').each(function(){
//         //     var currentThumbImg = this;
//         //     var tweenThumbImg = new TimelineMax()
//         //         .to(currentThumbImg, 1, {transform: "translate(0,150px)", ease: Linear.easeNone});
//         //
//         //     new ScrollMagic.Scene({
//         //         triggerElement: currentThumbImg,
//         //         triggerHook: "onEnter",
//         //         duration: 2000
//         //     })
//         //         .setTween(tweenThumbImg)
//         //         .addTo(scrollMagicHomeController);
//         // });
//     }

//     if($('.Home #step1').length){
//         new ScrollMagic.Scene({ triggerElement: ".HomeEvent", triggerHook: "onEnter", duration: "300%"})
//             .setClassToggle('.BodyLayout-mainContent', 'is-coming')
//             .setTween($('.HomeEvent .ArticleHeader-h1'), {transform: "translate(-300vw,0)", ease: Linear.easeNone})
//             .addTo(scrollMagicHomeController);
//         new ScrollMagic.Scene({ triggerElement: "#step1", triggerHook: "onCenter", duration: 0})
//             .setTween($('.BodyLayout-mainContent'), {backgroundColor: "#A9382E", ease: Linear.easeNone})
//             .addTo(scrollMagicHomeController);
//     }

//     if($('.Home #step2').length){
//         new ScrollMagic.Scene({ triggerElement: ".HomeWebzine", triggerHook: "onEnter", duration: "300%"})
//             .setClassToggle('.BodyLayout-mainContent', 'is-webzine')
//             .setTween($('.HomeWebzine .ArticleHeader-h1'), {transform: "translate(-300vw,0)", ease: Linear.easeNone})
//             .addTo(scrollMagicHomeController);
//     }

//     // if($('.Home #step3').length){
//     //     new ScrollMagic.Scene({ triggerElement: ".HomeHelloSpot", triggerHook: "onEnter", duration: "300%"})
//     //         .setClassToggle('.BodyLayout-mainContent', 'is-hellospot')
//     //         .setTween($('.HomeHelloSpot .ArticleHeader-h1'), {transform: "translate(-300vw,0)", ease: Linear.easeNone})
//     //         .addTo(scrollMagicHomeController);
//     //     new ScrollMagic.Scene({ triggerElement: "#step3", triggerHook: "onCenter", duration: 0})
//     //         .setTween($('.BodyLayout-mainContent'), {backgroundColor: "#413A33", ease: Linear.easeNone})
//     //         .addTo(scrollMagicHomeController);
//     // }

//     if($('.Home #step4').length){
//         new ScrollMagic.Scene({ triggerElement: ".HomeStream", triggerHook: "onEnter", duration: "300%"})
//             .setClassToggle('.BodyLayout-mainContent', 'is-rezo')
//             .setTween($('.HomeStream .ArticleHeader-h1'), {transform: "translate(-300vw,0)", ease: Linear.easeNone})
//             .addTo(scrollMagicHomeController);
//         new ScrollMagic.Scene({ triggerElement: "#step4", triggerHook: "onCenter", duration: 0})
//             //.setTween($('.BodyLayout-mainContent'), {backgroundColor: "#0E0905", ease: Linear.easeNone})
//             .setTween($('.BodyLayout-mainContent'), {backgroundColor: "#0FB3D4", ease: Linear.easeNone})
//             .addTo(scrollMagicHomeController);
//     }

//     // $('strong').each(function(){
//     //     var currentStrong = this;
//     //
//     //     var tweenStrong = new TimelineMax()
//     //         .to(currentStrong, 0.25, {css: {fontWeight: 400, textShadow:"0px 0px 20px rgba(18, 112, 200, 1)"}});
//     //
//     //     var scene = new ScrollScene({triggerElement: currentStrong, offset: -$(window).height()*0.7})
//     //         .setTween(tweenStrong)
//     //         .addTo(scrollMagicHomeController);
//     // });

//     // Add debug indicators fixed on right side
//     // scene_ads.addIndicators();
// });

$(window).load(function(){
    if( $('.MagellanMenu').length){
        var windowScrollTop = 0,
            windowHeight = $(window).height();

        $('.MagellanMenu .menu li a').each(function () {
            $this = $(this);
            var magellanArticle = $($this.attr('href')),
                magellanArticlePositionTop = $(magellanArticle).position().top,
                magellanArticleHeight = $(magellanArticle).height(),
                magellanProgressBarExists = $('.MagellanMenu').length > 0,
                magellanProgressBar = $this.find('span.rib');

            function updateMagellanProgressBar() {
                var magellanProgressBarPercent = 100 - ((windowScrollTop - magellanArticlePositionTop) * 100 / magellanArticleHeight);
                if(magellanProgressBarPercent > 0) {
                    magellanProgressBar.css({'bottom': magellanProgressBarPercent + '%'});
                }

                //console.log(magellanProgressBarPercent);
            }

            $(window).scroll(function(){
                windowScrollTop = $(window).scrollTop();

                if(magellanProgressBarExists) {
                    updateMagellanProgressBar();
                }

            });
        });
    }
});
